import type { FC, ReactNode } from 'react'

import { ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TransitionLink } from '@/components/generals/transition-link'

interface MoreLinkProps {
    href: string
    label: string
    className?: string
}

/** Quiet text link that leads from a home chapter to its full page. Inherits the text colour. */
export const MoreLink: FC<MoreLinkProps> = ({ href, label, className }): ReactNode => {
    return (
        <TransitionLink
            href={href}
            className={cn('group inline-flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.22em]', className)}
        >
            <span className='relative py-1'>
                {label}

                <span
                    aria-hidden='true'
                    className='absolute inset-x-0 bottom-0 h-px origin-left bg-current transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-x-0 group-hover:origin-right'
                />
            </span>

            <span className='flex size-10 items-center justify-center rounded-full border border-current/30 transition-colors duration-500 group-hover:border-current'>
                <ArrowUpRight
                    aria-hidden='true'
                    className='size-4 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5'
                />
            </span>
        </TransitionLink>
    )
}
